var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackBtnImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 18,
    viewBox: "0 0 10 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.47134 -1.3364e-07C8.05278 -1.70232e-07 7.71611 0.156523 7.42493 0.469566L0.573248 7.65C0.181983 8.07065 0.00909793 8.48152 -1.12054e-06 9C-1.16502e-06 9.50869 0.181983 9.93913 0.573248 10.35L7.41583 17.5402C7.71611 17.8435 8.06187 18 8.47134 18C9.30846 18 10 17.2761 10 16.3761C10 15.9261 9.81802 15.5152 9.50864 15.1728L3.56688 8.99022L9.50865 2.82717C9.82712 2.48478 10 2.07391 10 1.62391C10 0.733696 9.30846 -6.04562e-08 8.47134 -1.3364e-07Z",
    fill: "#FCFCFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackBtnImg);
export default __webpack_public_path__ + "static/media/backBtnImg.3bbf4f770085459aa76c76524d68c119.svg";
export { ForwardRef as ReactComponent };